import Angular from "angular";
import Loader from "angular-ecmascript/module-loader";
import {Service} from "angular-ecmascript/module-helpers";
import Settings from "../providers/settings.provider";
import Branch from "../model/branch.model";

export var Name = 'Branches';

export class Branches extends Service {
    static $name = Name;
    static $inject = ['$q', 'Restangular', 'CacheFactory', 'settings'];

    create() {
        // NOOP.
    }

    all() {
        var defer = this.$q.defer();

        this.Restangular
            .setBaseUrl(this.settings.httpUrl('app'))
            .all('branches')
            .withHttpConfig({cache: this.CacheFactory.get('http')})
            .getList()
            .then((response) => {
                var branches = response.map((branchData) => {
                    return this.Restangular.copy(new Branch(branchData));
                });

                defer.resolve(branches);
            })
            .catch((err) => {
                defer.reject(err);
            });


        return defer.promise;
    }

}

var BranchesModule = Angular.module('branches-service', ['restangular', Settings.name]);

new Loader(BranchesModule)
    .load(Branches);

export default BranchesModule;



// WEBPACK FOOTER //
// ./src/modules/main/services/branches.service.js